import React from 'react'
import styled from '@emotion/styled'
import { object, string } from 'prop-types'
import { AuthorBio } from '../AuthorBio'

const Title = styled.h1`
	${({ theme }) => theme.fonts.bold};
	border-bottom: 1rem solid ${({ theme }) => theme.contentHeader.authorBylineBorder};
	color: ${({ theme }) => theme.colors.gray[700]};
	font-size: 32px;
	margin: 0 auto;
	padding-bottom: 1rem;
`

ContentHeader.propTypes = {
	author: object.isRequired,
	byLine: string,
	lastModified: string.isRequired,
	published: string.isRequired,
	sponsorship: object,
	title: string.isRequired,
}

export function ContentHeader({ author, byLine, lastModified, published, sponsorship, title }) {
	return (
		<>
			<Title>{title}</Title>
			<AuthorBio
				author={author}
				byLine={byLine}
				lastModified={lastModified}
				published={published}
				sponsorship={sponsorship}
			/>
		</>
	)
}
